import axios from 'axios'
import Config from '../config.js'

const serverHost = 'https://cobalt-crm.ru/'

const instance = axios.create({
	//baseURL: 'http://kanban-server/',
	baseURL: Config.SERVER,
	timeout: 10000
});

export function addResponseHandler(success, error){
	instance.interceptors.response.use(success, error);
}

export default instance;